import {
  ActiveFiltersContainer,
  FacetsContainer,
  FilterButton,
  SortStatsWrapper,
  StatsWrapper,
} from "./Facets.styled";
import { Filters } from "./Filters";
import { ActiveFilters } from "./ActiveFilters";
import { Sort } from "./Sort";
import { Stats } from "./Stats";
import { Filtering } from "src/icons";
import { Trans } from "@lingui/macro";
import { Text } from "@otrium/atoms";
import NoSSR from "src/atoms/NoSSR";
import { useBreakpoints } from "@otrium/core";
import { MobileFilters } from "src/organisms/MobileFilters";
import { useCallback, useMemo, useState } from "react";
import { useCurrentRefinements } from "react-instantsearch-core-v7";
import { PLPType } from "src/types/PLPType.d";
import { SEGMENT_LIST_FORMAT } from "src/segment";
import { localeFix } from "src/utils/genderLocale/genderLocale";
import { useFilterTracking } from "src/hooks/use-filter-tracking";
import { listTypes } from "src/utils/algolia/contextKeys";

function Facets({
  excludeFilters = [],
  categoryPageId,
  gender,
  pageContentType,
  title,
  indexName,
}: {
  excludeFilters?: string[];
  categoryPageId: string;
  gender: string;
  pageContentType: PLPType;
  title?: string;
  indexName: string;
}): JSX.Element {
  const { isDesktop } = useBreakpoints();
  const [isMobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const { items } = useCurrentRefinements();

  const { trackFilterReset } = useFilterTracking({
    listFormat: SEGMENT_LIST_FORMAT.default,
    listId: title || listTypes[pageContentType],
    listType: listTypes[pageContentType],
    shopType: localeFix({ gender }),
    indexName,
  });

  const totalFilters = useMemo(
    () => items.flatMap((item) => item.refinements).length,
    [items]
  );

  const toggleMobileFilters = useCallback(
    () => setMobileFiltersOpen((prevState) => !prevState),
    [setMobileFiltersOpen]
  );

  return (
    <NoSSR>
      <FacetsContainer>
        {isDesktop ? <Filters excludeFilters={excludeFilters} /> : null}
        <StatsWrapper>
          <FilterButton onClick={toggleMobileFilters}>
            <Filtering />
            <Text display="flex" fontWeight={600} ml={2} color={"Black"}>
              <Trans>Filters</Trans>
              {totalFilters > 0 ? <span>{`(${totalFilters})`}</span> : null}
            </Text>
          </FilterButton>
          <SortStatsWrapper>
            <Stats />
            <Sort />
          </SortStatsWrapper>
        </StatsWrapper>
      </FacetsContainer>

      {isDesktop && totalFilters > 0 ? (
        <ActiveFiltersContainer>
          <ActiveFilters trackFilterReset={trackFilterReset} />
        </ActiveFiltersContainer>
      ) : null}

      {!isDesktop ? (
        <MobileFilters
          isOpen={isMobileFiltersOpen}
          categoryPageId={categoryPageId}
          gender={gender}
          toggleMobileFilters={toggleMobileFilters}
          pageContentType={pageContentType}
          excludeFilters={excludeFilters}
          trackFilterReset={trackFilterReset}
        />
      ) : null}
    </NoSSR>
  );
}

export { Facets };
